import { render, staticRenderFns } from "./GenerateCode.vue?vue&type=template&id=c5cef896"
import script from "./GenerateCode.vue?vue&type=script&lang=js"
export * from "./GenerateCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports